import React, { ReactElement, useEffect } from 'react';
import { ViewStyle } from 'react-native';
import { useDispatch } from 'react-redux';

import { CloseButton } from 'components/Media/PlayerControls/CloseButton';
import { useContentRedirectContext } from 'components/ProvidersContainer/ContentRedirectProvider';
import { useSafeParams } from 'components/Routes/useSafeParams';
import { RoleProps } from 'cross-platform/utils/roleProps';
import { showControlsCloseButton } from 'state/player/actions';

type ModalCloseButtonProps = {
  style: ViewStyle;
} & RoleProps;

// A Wrapper around CloseButton, this version of Close Button
// will be used by Modal.
//
// Upon mounting, the component will update a flag inside the Redux Store
// that will hide the ContentCloseButton inside Player Controls.
//
// Upon unmounting, the component will update same flag back to its original state
// and as the result ContentCloseButton will reappear
//
// ModalCloseButton and ContentCloseButton should be mutually exclusive
export const ModalCloseButton = ({
  style,
  ...roleProps
}: ModalCloseButtonProps): ReactElement => {
  const dispatch = useDispatch();
  const { exitContent } = useContentRedirectContext();
  const { productReference } = useSafeParams();

  useEffect(() => {
    dispatch(showControlsCloseButton(false));
    return () => {
      dispatch(showControlsCloseButton(true));
    };
  }, [dispatch]);

  const handlePress = () => {
    exitContent({ fallback: 'home', productReference });
  };

  return <CloseButton {...roleProps} style={style} onPress={handlePress} />;
};
